import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Mail, CreditCard, AlertCircle } from 'lucide-react';
export const Refund = () => {
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-599">
      <Helmet data-id="element-600">
        <title data-id="element-601">Refund Policy | Taskpoint Appliance Repairs</title>
        <meta name="description" content="Fair refund policy for appliance repair services. Secure Stripe payments with 14-day full refund option for UK washing machine and appliance engineers." data-id="element-602" />
        <meta name="keywords" content="appliance repair refund, washing machine engineer, service refund policy, UK appliance diagnostics, same-day appliance repair, secure payment" data-id="element-603" />
      </Helmet>
      <Header data-id="element-604" />
      <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700 text-white" data-id="element-605">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-606">
          <h1 className="text-5xl font-bold mb-6" data-id="element-607">Refund Policy</h1>
          <p className="text-xl text-teal-50 max-w-3xl" data-id="element-608">
            Transparent refund terms for our appliance repair services
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-609">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-610">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-611">
            <div className="mb-8" data-id="element-612">
              <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-613">
                Your Refund Rights
              </h2>
              <p className="text-slate-600 leading-relaxed mb-6" data-id="element-614">
                We aim to resolve concerns quickly and fairly. Here's how our
                refund process works:
              </p>
              <div className="space-y-6" data-id="element-615">
                <div className="p-6 bg-teal-50 rounded-lg" data-id="element-616">
                  <h3 className="font-semibold text-slate-800 mb-2" data-id="element-617">
                    0–14 Days: Full Refund Available
                  </h3>
                  <p className="text-slate-600" data-id="element-618">
                    Cancel within 14 days for a full refund if no repair work
                    has been completed.
                  </p>
                </div>
                <div className="p-6 bg-slate-50 rounded-lg" data-id="element-619">
                  <h3 className="font-semibold text-slate-800 mb-2" data-id="element-620">
                    15–28 Days: Partial Refund Possible
                  </h3>
                  <p className="text-slate-600" data-id="element-621">
                    A partial refund may be offered at our discretion, depending
                    on the work already carried out.
                  </p>
                </div>
                <div className="p-6 bg-slate-100 rounded-lg" data-id="element-622">
                  <h3 className="font-semibold text-slate-800 mb-2" data-id="element-623">
                    After 28 Days: No Refunds
                  </h3>
                  <p className="text-slate-600" data-id="element-624">
                    Refunds are not available after 28 days from the service
                    purchase date.
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-8" data-id="element-625">
              <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-626">
                How to Request a Refund
              </h2>
              <p className="text-slate-600 mb-6" data-id="element-627">
                To request a refund for your repair service, please contact us:
              </p>
              <div className="space-y-4" data-id="element-628">
                <div className="flex items-center space-x-3" data-id="element-629">
                  <Mail className="w-6 h-6 text-teal-600" data-id="element-630" />
                  <a href="mailto:Benjobalolong082@gmail.com" className="text-teal-600 hover:underline break-all" data-id="element-631">
                    Benjobalolong082@gmail.com
                  </a>
                </div>
                <div className="flex items-center space-x-3" data-id="element-632">
                  <Phone className="w-6 h-6 text-teal-600" data-id="element-633" />
                  <a href="tel:08000554969" className="text-teal-600 hover:underline text-lg font-semibold" data-id="element-634">
                    0800 055 4969
                  </a>
                </div>
              </div>
              <p className="text-slate-600 mt-6" data-id="element-635">
                All approved refunds are returned to the original payment
                method.
              </p>
            </div>
            <div className="mb-8" data-id="element-636">
              <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-637">
                Secure Payments
              </h2>
              <div className="flex items-start space-x-4" data-id="element-638">
                <CreditCard className="w-8 h-8 text-teal-600 flex-shrink-0 mt-1" data-id="element-639" />
                <div data-id="element-640">
                  <p className="text-slate-600 mb-4" data-id="element-641">
                    We accept secure online card payments via Stripe checkout.
                    Your 14-day refund right applies regardless of payment
                    method used.
                  </p>
                  <p className="text-slate-600" data-id="element-642">
                    All transactions are encrypted and processed securely
                    through our trusted payment provider.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg" data-id="element-643">
              <div className="flex items-start space-x-3" data-id="element-644">
                <AlertCircle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-645" />
                <div data-id="element-646">
                  <h3 className="font-semibold text-slate-800 mb-2" data-id="element-647">
                    Dispute Resolution
                  </h3>
                  <p className="text-slate-600" data-id="element-648">
                    Please contact us directly before raising a bank dispute.
                    This approach ensures we can address your concerns quickly
                    and effectively, avoiding unnecessary delays.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-649" />
    </div>;
};